<template>
    <div class="kgr-grid kgr-grid--gutters kgr-grid--inlineBlock animated fadeIn">
        <div
            v-for="member in members"
            :key="member.id"
            class="kgr-grid__cell app-gridCard container_child"
        >
            <div class="kgr-card">
                <kgr-member-contract-state-icon
                    banderol
                    :state="member.contractState"
                    @mouseover="toggleContractsLayer(member, true)"
                    @mouseout="toggleContractsLayer(member, false)"
                />

                <kgr-profile-image
                    :src="memberAvatarUrl(member)"
                    :alt="member.fullName()"
                    size="M"
                    class="kgr-card__image"
                />

                <h3
                    class="kgr-card__name child_name"
                    :class="{ 'kgr-card__name--noSeparator': member.membershipNumber }"
                >
                    <span v-if="member.isShortProfileViewable === false">
                        {{ member.fullName() }}
                    </span>
                    <a
                        v-else
                        :href="urlForMember(member.id)"
                    >
                        {{ member.fullName() }}
                    </a>
                    <div
                        v-if="member.membershipNumber !== null"
                        class="withMembershipNumber"
                    >
                        #{{ member.membershipNumber }}
                    </div>
                </h3>

                <div
                    class="kgr-card__contents"
                    style="overflow: hidden;"
                >
                    <kgr-member-contracts-layer
                        v-if="showContractsLayer(member)"
                        :class="{ fadeOutRight: !showContractsLayer(member) }"
                        :member-contract-history="member.contractHistory"
                    />
                    <template v-else>
                        <div class="address">
                            <div v-if="member.company && member.careOf">
                                {{ member.company }}
                            </div>
                            <div v-else-if="member.company">
                                {{ member.company }}
                            </div>
                            <div v-else-if="member.careOf">
                                c/o {{ member.careOf }}
                            </div>
                            <div>{{ member.street }}</div>
                            <div>{{ member.zip }} {{ member.city }}</div>
                        </div>

                        <div class="contact">
                            <div v-if="member.phone">
                                <i class="icon icon-phone icon-smaller"></i> {{ member.phone }}
                            </div>
                            <div v-if="member.phoneMobile">
                                <i class="icon icon-mobile icon-smaller"></i> {{ member.phoneMobile }}
                            </div>
                        </div>
                    </template>
                </div>

                <div
                    v-if="member.isEditableBasicData"
                    class="kgr-card__footer"
                >
                    <a
                        :href="urlForMemberEdit(member.id)"
                        class="kgr-card__footerFullButton kgr-button kgr-button--accent kgr-button--small kgr-button--block"
                    >
                        {{ $t('edit') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KgrMemberContractStateIcon from './MemberContractStateIcon.vue';
import MemberContracsLayer from './MemberContracsLayer.vue';
import ProfileImage from '../common/ProfileImage';
import UrlMixin from './UrlMixin';

export default {
    components: {
        KgrMemberContractStateIcon,
        'kgr-profile-image': ProfileImage,
        'kgr-member-contracts-layer': MemberContracsLayer,
    },
    mixins: [UrlMixin],
    props: {
        members: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            visibleContractLayer: null,
        };
    },
    methods: {
        toggleContractsLayer(member, visible) {
            if (member.contractHistory === null) {
                return;
            }
            this.visibleContractLayer = visible ? member : null;
        },
        showContractsLayer(member) {
            return member.contractHistory !== null && member === this.visibleContractLayer;
        },
        memberAvatarUrl(member) {
            return this.avatarUrl(member.id, member.hasAvatar, member.gender, member.avatarFileName);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .withMembershipNumber {
    font-size: 0.7em;
    margin-bottom: -0.3em;
}
</style>
